
const validate = (props) => {
    const errors = {}
    console.log("error message",props)
    if (!props.type) {
        errors.type = {
            ar: ' يرجى اختيار النوع  ',
            en: 'Please choose type'
        }
    } 
    if (!props.email) {
        errors.email = {
            ar: 'يرجى ادخال البريد الالكتروني او اسم المستخدم' ,
            en: 'Enter your email or user name'
        }
    }     
    if (!props.password) {
        errors.password = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    } 

    return errors
}

export default validate;